module.exports = __webpack_public_path__ + "img/chambreetage2.37b427e4.jpg";